import React from 'react'

type ConditionalWrapperProps = {
  condition?: boolean
  wrapper: (children: React.JSX.Element) => React.JSX.Element
  children: React.JSX.Element
}

export function ConditionalWrapper({
  condition,
  wrapper,
  children,
}: ConditionalWrapperProps): React.JSX.Element {
  return condition ? wrapper(children) : children
}
